import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['correctFeedback', 'correctFeedbackText', 'incorrectFeedback', 'incorrectFeedbackText'];

  get pageNavNext() {
    return this.element.querySelector('#page-nav .next a');
  }

  connect() {
    const week4Submit = document.querySelector(".week4-submit");

    if (week4Submit) {
      this.disableNextNavigation();
      document.querySelectorAll(".mdc-radio").forEach((radio) => {
        const radioInput = radio.querySelector("input");
        radioInput.addEventListener("change", () => {
          week4Submit.removeAttribute("disabled");
        });
      });
      week4Submit.addEventListener("click", () => {
        document.querySelectorAll(".mdc-radio").forEach((radio) => {
          const radioInput = radio.querySelector("input");
          const radioContainer = radio.closest(".week4-radio");

          if (radioInput.checked) {
            let feedback = radioContainer.querySelector(".week4-feedback").innerText;
            if (radioContainer.classList.contains("correct")) {
              this.enableNextNavigation();
              this.incorrectFeedbackTarget.style.display = 'none';
              this.correctFeedbackTextTarget.innerText = feedback;
              this.correctFeedbackTarget.style.display = 'block';
              radioContainer.querySelector('label').classList.add('correct');
            } else {
              this.correctFeedbackTarget.style.display = 'none';
              this.incorrectFeedbackTextTarget.innerText = feedback;
              this.incorrectFeedbackTarget.style.display = 'block';
              radioContainer.querySelector('label').classList.add('incorrect');
            }
          }
        });
      });
    }
  }

  disableNextNavigation() {
    this.pageNavNext.setAttribute("disabled", "disabled");
  }

  enableNextNavigation() {
    this.pageNavNext.removeAttribute('disabled');
  }
}
